import { Component } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { LoaderService } from './modules/shared/services/loader.service';
import { NgIf } from '@angular/common';
import { LoaderComponent } from './modules/shared/components/loader/loader.component';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterModule, NgIf, LoaderComponent],
  templateUrl: './app.component.html',
  providers: [provideAnimations()]
})
export class AppComponent {
  public isLoading: boolean = false;

  constructor(private _loaderService: LoaderService) {
    this._loaderService.loaderState$.subscribe(state => {
      this.isLoading = state;
    });
  }
}
